// @ts-nocheck
import { PASSIVE_TREES, SPELLS, spellSearchAliases } from "../data";

let query = "";
let wired = false;
let matchIndex = 0;
let lastScrollMatch = null;
let searchIdleTimer = null;

const SEARCH_IDLE_MS = 3000;
const SEARCH_PULSE_MS = 550 * 3 + 80;

function keyTargetIsTextField(el) {
  if (!el) return false;
  const tag = el.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
}

function catalogContext() {
  const spellbook = document.getElementById("spellbook");
  if (spellbook && !spellbook.classList.contains("hidden")) {
    const grid = document.getElementById("spellbookCatalog");
    if (grid) return { root: spellbook, grid };
  }
  const shop = document.getElementById("shop");
  if (shop && !shop.classList.contains("hidden")) {
    const spellsPanel = document.getElementById("shopSpellsPanel");
    if (spellsPanel?.classList.contains("hidden")) return null;
    const grid = document.getElementById("shopGrid");
    if (grid) return { root: shop, grid };
  }
  return null;
}

function matchesQuery(text, q) {
  if (!text || !q) return false;
  return text.toLowerCase().includes(q.toLowerCase());
}

function spellSearchText(spellId) {
  const s = SPELLS[spellId];
  if (!s) return "";
  const tree = PASSIVE_TREES[spellId] || [];
  const treeText = tree.map(n => {
    const parts = [n.name];
    if (n.synergy && n.requiresSpell) {
      const partner = SPELLS[n.requiresSpell];
      if (partner) parts.push(partner.name);
    }
    return parts.filter(Boolean).join(" ");
  }).join(" ");
  return [s.name, s.type, s.school, spellSearchAliases(spellId), treeText].filter(Boolean).join(" ");
}

function passiveSearchText(spellId, passiveId) {
  const tree = PASSIVE_TREES[spellId] || [];
  const n = tree.find(x => x.id === passiveId);
  if (!n) return "";
  const parts = [n.name];
  if (n.synergy && n.requiresSpell) {
    const partner = SPELLS[n.requiresSpell];
    if (partner) parts.push(partner.name);
  }
  return parts.filter(Boolean).join(" ");
}

function passiveSpellId(node) {
  return node.closest("[data-skill-tree-spell]")?.dataset?.skillTreeSpell ||
    node.getAttribute("data-tip-spell") || "";
}

function deleteLastWord(q) {
  if (!q) return "";
  let end = q.length;
  while (end > 0 && /\s/.test(q[end - 1])) end--;
  if (end === 0) return "";
  let start = end;
  while (start > 0 && !/\s/.test(q[start - 1])) start--;
  return q.slice(0, start);
}

function clearSearchIdleTimer() {
  if (searchIdleTimer) {
    clearTimeout(searchIdleTimer);
    searchIdleTimer = null;
  }
}

function bumpSearchIdle() {
  clearSearchIdleTimer();
  if (!query) return;
  searchIdleTimer = setTimeout(() => {
    searchIdleTimer = null;
    resetSearch();
  }, SEARCH_IDLE_MS);
}

function pulseSearchMatch(el) {
  if (!el || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  el.classList.remove("catalog-search-pulse");
  void el.offsetWidth;
  el.classList.add("catalog-search-pulse");
  setTimeout(() => el.classList.remove("catalog-search-pulse"), SEARCH_PULSE_MS);
}

function scrollContainerFor(grid) {
  return grid.closest(".shop-scroll");
}

function isVisibleInScroller(el, scroller) {
  const elRect = el.getBoundingClientRect();
  const scRect = scroller.getBoundingClientRect();
  const pad = 12;
  return elRect.top >= scRect.top + pad && elRect.bottom <= scRect.bottom - pad;
}

function scrollElIntoContainer(el, scroller) {
  const elRect = el.getBoundingClientRect();
  const scRect = scroller.getBoundingClientRect();
  const offset = elRect.top - scRect.top + scroller.scrollTop;
  const target = offset - (scroller.clientHeight - elRect.height) / 2;
  scroller.scrollTo({ top: Math.max(0, target), behavior: "smooth" });
}

function getSearchMatches(grid) {
  return [...grid.querySelectorAll(".catalog-search-match")];
}

function clearMatchFocus(grid) {
  grid.querySelectorAll(".catalog-search-match-current").forEach(el => {
    el.classList.remove("catalog-search-match-current");
  });
}

function focusMatchAt(grid, index, opts = {}) {
  const { forceScroll = false, pulse = false } = opts;
  const matches = getSearchMatches(grid);
  clearMatchFocus(grid);
  if (!matches.length) {
    lastScrollMatch = null;
    matchIndex = 0;
    return;
  }
  const i = ((index % matches.length) + matches.length) % matches.length;
  matchIndex = i;
  const el = matches[i];
  el.classList.add("catalog-search-match-current");
  const scroller = scrollContainerFor(grid);
  if (!scroller) return;
  const shouldScroll = forceScroll || el !== lastScrollMatch || !isVisibleInScroller(el, scroller);
  if (shouldScroll) {
    lastScrollMatch = el;
    scrollElIntoContainer(el, scroller);
  }
  if (pulse || shouldScroll) pulseSearchMatch(el);
}

function clearGridSearch(grid) {
  grid.classList.remove("catalog-search-active");
  grid.querySelectorAll(".catalog-search-match, .catalog-search-match-current, .catalog-search-pulse").forEach(el => {
    el.classList.remove("catalog-search-match", "catalog-search-match-current", "catalog-search-pulse");
  });
}

function cleanupAll() {
  for (const id of ["shopGrid", "spellbookCatalog"]) {
    const grid = document.getElementById(id);
    if (grid) clearGridSearch(grid);
  }
  for (const id of ["shop", "spellbook"]) {
    updateOverlay(document.getElementById(id), "");
  }
}

function applySearch(grid, q) {
  clearGridSearch(grid);
  if (!q) return;
  grid.classList.add("catalog-search-active");
  grid.querySelectorAll(".spell-card[data-spell-id]").forEach(card => {
    const id = card.getAttribute("data-spell-id");
    if (matchesQuery(spellSearchText(id), q)) card.classList.add("catalog-search-match");
  });
  grid.querySelectorAll(".passive-node[data-passive-id]").forEach(node => {
    const spellId = passiveSpellId(node);
    const passiveId = node.getAttribute("data-passive-id");
    if (matchesQuery(passiveSearchText(spellId, passiveId), q)) {
      node.classList.add("catalog-search-match");
    }
  });
}

function seededUnit(seed) {
  const x = Math.sin(seed * 127.1 + 311.7) * 43758.5453;
  return x - Math.floor(x);
}

function charStyle(i) {
  const jy = seededUnit(i * 1.7 + 0.3);
  const jx = seededUnit(i * 2.1 + 0.9);
  const jr = seededUnit(i * 3.3 + 1.1);
  return {
    left: i * 36 + (jx - 0.5) * 10,
    top: 10 + (jy - 0.5) * 34,
    rotate: (jr - 0.5) * 16,
  };
}

function updateOverlay(root, q) {
  if (!root) return;
  const layer = root.querySelector(".catalog-search-layer");
  root.querySelectorAll(".catalog-search-hint").forEach(hint => {
    hint.classList.toggle("hidden", !!q);
  });
  if (!layer) return;
  const queryEl = layer.querySelector(".catalog-search-query");
  layer.classList.toggle("is-searching", !!q);
  if (!queryEl) return;
  queryEl.innerHTML = "";
  if (!q) return;
  [...q].forEach((ch, i) => {
    const span = document.createElement("span");
    const { left, top, rotate } = charStyle(i);
    span.className = "catalog-search-char";
    span.textContent = ch === " " ? "\u00a0" : ch;
    span.style.left = `${left}px`;
    span.style.top = `${top}px`;
    span.style.transform = `rotate(${rotate}deg)`;
    queryEl.appendChild(span);
  });
}

function apply(ctx, opts = {}) {
  const resetIndex = opts.resetIndex !== false;
  if (resetIndex) {
    matchIndex = 0;
    lastScrollMatch = null;
  }
  applySearch(ctx.grid, query);
  updateOverlay(ctx.root, query);
  if (query) focusMatchAt(ctx.grid, resetIndex ? 0 : matchIndex);
}

function resetSearch() {
  query = "";
  matchIndex = 0;
  lastScrollMatch = null;
  clearSearchIdleTimer();
  cleanupAll();
}

function advanceSearchMatch(ctx) {
  if (!query) return false;
  const matches = getSearchMatches(ctx.grid);
  if (matches.length <= 1) return false;
  focusMatchAt(ctx.grid, matchIndex + 1, { forceScroll: true, pulse: true });
  bumpSearchIdle();
  return true;
}

function onKeyDown(e) {
  const ctx = catalogContext();
  if (!ctx) return;
  if (keyTargetIsTextField(e.target)) return;
  if (e.key === "Escape") {
    if (!query) return;
    e.preventDefault();
    e.stopPropagation();
    resetSearch();
    return;
  }
  if (e.key === "Backspace") {
    if (!query) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.metaKey || e.ctrlKey) query = "";
    else if (e.altKey) query = deleteLastWord(query);
    else query = query.slice(0, -1);
    if (!query) resetSearch();
    else {
      apply(ctx);
      bumpSearchIdle();
    }
    return;
  }
  if (e.key === "Enter" || e.key === "Tab") {
    if (!advanceSearchMatch(ctx)) return;
    e.preventDefault();
    e.stopPropagation();
    return;
  }
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (e.key.length !== 1 || e.key < " " || e.key === "Dead") return;
  e.preventDefault();
  e.stopPropagation();
  query += e.key;
  apply(ctx);
  bumpSearchIdle();
}

function observePanels() {
  for (const id of ["shop", "spellbook"]) {
    const el = document.getElementById(id);
    if (!el) continue;
    new MutationObserver(() => {
      if (el.classList.contains("hidden")) resetSearch();
      else refreshSpellCatalogSearch();
    }).observe(el, { attributes: true, attributeFilter: ["class"] });
  }
  const spellsPanel = document.getElementById("shopSpellsPanel");
  if (spellsPanel) {
    new MutationObserver(() => refreshSpellCatalogSearch()).observe(spellsPanel, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }
}

export function clearSpellCatalogSearch() {
  resetSearch();
}

export function refreshSpellCatalogSearch() {
  const ctx = catalogContext();
  if (!ctx) {
    if (query) resetSearch();
    return;
  }
  if (!query) return;
  applySearch(ctx.grid, query);
  updateOverlay(ctx.root, query);
  focusMatchAt(ctx.grid, matchIndex);
}

export function wireSpellCatalogSearch() {
  if (wired) return;
  wired = true;
  window.addEventListener("keydown", onKeyDown, true);
  observePanels();
}
